<template>
  <div
    v-if="globalMessage"
    ref="globalMessage"
    :class="`alert-${globalMessage.style}`"
    class="alert rounded-0 mb-0"
    role="alert"
  >
    <template v-if="globalMessage.type === 'MAINTAIN'">
      {{
        $t('common.maintainMessage', [
          $dayjs
            .utc(globalMessage.data.startTime)
            .tz()
            .format('HH:mm'),
          $dayjs
            .utc(globalMessage.data.endTime)
            .tz()
            .format('HH:mm')
        ])
      }}
    </template>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  onMounted,
  useStore,
  watch
} from '@nuxtjs/composition-api'

export default defineComponent({
  setup(props, context) {
    const store = useStore()
    const globalMessage = computed(() => store.state.globalMessage)
    watch(globalMessage, (newVal, oldVal) => {
      context.emit('watchChange', {
        newVal,
        oldVal
      })
    })

    onMounted(() => {
      if (globalMessage.value) {
        context.emit('watchChange', {
          newVal: globalMessage.value,
          oldVal: null
        })
      }
    })

    return {
      globalMessage
    }
  }
})
</script>
